<object-detection-image-canvas class="w100 h100" [imagePath]="imagePath" [label]="label" (labelChange)="onLabelChange$.next($event)"></object-detection-image-canvas>
 